import {onMessage} from 'firebase/messaging';
import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

import {messaging} from 'services/firebase';

function NotificationHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      const route = payload.data?.route;
      if (route) {
        navigate(route);
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  return null;
}

export default NotificationHandler;
